<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div v-show="activeName=='1'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="作业名称：">
							<el-input v-model="finiOntaskName" placeholder="请输入作业名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="发布人：">
							<el-input v-model="finiOnuserName" placeholder="请输入发布人" clearable></el-input>
						</el-form-item>
						<br />
						<el-form-item label="实验名称：">
							<el-input v-model="finiOnname" placeholder="请输入实验名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="实验类型：">
							<el-select :popper-append-to-body='false' v-model="finiOntypeId" placeholder="请选择实验类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOnCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOnFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOnlistData" ref='centerfiniOnTable' border stripe>
					<emptymain slot='empty' :emptylist='finiOnlistData'></emptymain>
					<el-table-column type="expand">
						<template slot-scope="scope">
							<div class="center_tableAppend">
								<el-table :data="scope.row.taskList || []" border stripe>
									<emptymain slot='empty' :emptylist='scope.row.taskList || []'></emptymain>
									<el-table-column prop="name" label="作业名称" align="center">
									</el-table-column>
									<el-table-column prop="endTime" label="提交截止日期" align="center">
										<template slot-scope="scope">
											{{scope.row.endTime | spliceForTask}}
										</template>
									</el-table-column>
									<el-table-column prop="createUsername" label="发布人" align="center">
									</el-table-column>
									<el-table-column prop="isFinish" label="当前状态" align="center">
										<template slot-scope="scope">
											<div class="task_status successColor" v-if='scope.row.isFinish'><img src="@/images/task_status1.png" />已提交</div>
											<div class="task_status infoColor" v-if='!scope.row.isFinish'><img src="@/images/task_status2.png" />未提交</div>
										</template>
									</el-table-column>
									<el-table-column label="操作" width='150' align="center">
										<template slot-scope="scope">
											<el-button size="mini" type="warning" :disabled="getDisabld(scope.row)" @click="startTask(scope.row)" v-if='!scope.row.isFinish'>写作业</el-button>
											<el-button size="mini" type="primary" @click="infoTask(scope.row)" v-if='scope.row.isFinish'>查看</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="实验封面" align='center'>
						<template slot-scope="scope">
							<div class="center_labinfo " >
								<img :src="baseurl + scope.row.cover" />
							</div>
						</template>
					</el-table-column>
					<el-table-column label="实验名称" prop="name" align='center' :show-overflow-tooltip='true'>
						<template slot-scope="scope">
							<span >{{scope.row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="实验类型" prop="typeName" align='center'>
					</el-table-column>
					<el-table-column label="作业数量" prop="tasKCount" align='center'>
						<template slot-scope="scope">
							<el-tag type='warning'>
								{{scope.row.tasKCount || 0}}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click='finiOnAppend(scope.row)'>详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOnCurrentChange" :current-page="finiOncurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOntotal">
				</el-pagination>
			</div>
		</div>
		<div v-show="activeName=='2'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="作业名称：">
							<el-input v-model="finiOfftaskName" placeholder="请输入作业名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="发布人：">
							<el-input v-model="finiOffuserName" placeholder="请输入发布人" clearable></el-input>
						</el-form-item>
						<br />
						<el-form-item label="实验名称：">
							<el-input v-model="finiOffname" placeholder="请输入实验名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="实验类型：">
							<el-select :popper-append-to-body='false' v-model="finiOfftypeId" placeholder="请选择实验类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOffCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOffFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOfflistData" ref='centerfiniOffTable' border stripe>
					<emptymain slot='empty' :emptylist='finiOfflistData'></emptymain>
					<el-table-column type="expand">
						<template slot-scope="scope">
							<div class="center_tableAppend">
								<el-table :data="scope.row.taskList || []" border stripe>
									<emptymain slot='empty' :emptylist='scope.row.taskList || []'></emptymain>
									<el-table-column prop="name" label="作业名称" align="center">
									</el-table-column>
									<el-table-column prop="endTime" label="提交截止日期" align="center">
										<template slot-scope="scope">
											{{scope.row.endTime | spliceForTask}}
										</template>
									</el-table-column>
									<el-table-column prop="createUsername" label="发布人" align="center">
									</el-table-column>
									<el-table-column prop="isFinish" label="当前状态" align="center">
										<template slot-scope="scope">
											<div class="task_status successColor" v-if='scope.row.isFinish'><img src="@/images/task_status1.png" />已提交</div>
											<div class="task_status infoColor" v-if='!scope.row.isFinish'><img src="@/images/task_status2.png" />未提交</div>
										</template>
									</el-table-column>
									<el-table-column label="操作" width='150' align="center">
										<template slot-scope="scope">
											<el-button size="mini" type="warning" :disabled="getDisabld(scope.row)" @click="startTask(scope.row)" v-if='!scope.row.isFinish'>写作业</el-button>
											<el-button size="mini" type="primary" @click="infoTask(scope.row)" v-if='scope.row.isFinish'>查看</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="实验封面" align='center'>
						<template slot-scope="scope">
							<div class="center_labinfo " >
								<img :src="baseurl + scope.row.cover" />
							</div>
						</template>
					</el-table-column>
					<el-table-column label="实验名称" prop="name" align='center' :show-overflow-tooltip='true'>
						<template slot-scope="scope">
							<span >{{scope.row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="实验类型" prop="typeName" align='center'>
					</el-table-column>
					<el-table-column label="作业数量" prop="tasKCount" align='center'>
						<template slot-scope="scope">
							<el-tag type='warning'>
								{{scope.row.tasKCount || 0}}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click='finiOffAppend(scope.row)'>详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOffCurrentChange" :current-page="finiOffcurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOfftotal">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="实验作业" class="open_dialogInfo" :visible.sync="taskOpenIndex" :append-to-body='true' width="1000px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<task-index v-if='taskOpenIndex' :taskId='taskId' @taskOver='taskOver'></task-index>
		</el-dialog>
		<el-dialog title="实验作业详情" class="open_dialogInfo" :visible.sync="taskOpenInfo" :append-to-body='true' width="1000px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<task-info v-if='taskOpenInfo' :taskId='taskId' :recordId='recordId'></task-info>
		</el-dialog>
	</div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth'
	import { listMajorByPid } from '@/api/major'
	import { getUserTaskRecordCenter } from '@/api/experimentWork.js'
	import taskIndex from '@/views/fictitious/components/labTaskIndex.vue'
	import taskInfo from '@/views/fictitious/components/labTaskDetails.vue'
	export default {
		components: {
			taskIndex,
			taskInfo,
		},
		data() {
			return {
				activeName: '1',
				commNavs: [{
					name: '未提交作业',
					id: '1'
				}, {
					name: '已提交作业',
					id: '2'
				}],
				limit: 10,
				typeList: [],
				//已完成
				finiOntaskName: '',
				finiOnuserName: '',
				finiOnname: '',
				finiOntypeId: '',
				finiOnlistData: [],
				finiOncurrent: 1,
				finiOntotal: 0,
				//未完成
				finiOfftaskName: '',
				finiOffuserName: '',
				finiOffname: '',
				finiOfftypeId: '',
				finiOfflistData: [],
				finiOffcurrent: 1,
				finiOfftotal: 0,
				//open
				taskOpenInfo: false,
				taskOpenIndex: false,
				taskId: '',
				recordId: '',
			};
		},
		created() {
			this.getTypeList();
			this.getfiniOnListData();
			this.getfiniOffListData();
		},
		methods: {
			taskOver() {
				this.taskOpenIndex = false;
				this.taskId = '';
				this.clearfiniOnFilter();
				this.clearfiniOffFilter();
			},
			getDisabld(item) {
				if(item.beginTime && item.endTime) {
					var nowTime = new Date();
					var beginTime = new Date(item.beginTime);
					var endTime = new Date(item.endTime);
					if(nowTime > beginTime && nowTime < endTime) {
						return false
					} else {
						return true
					}
				} else {
					return true
				}
			},
			startTask(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime);
				var endTime = new Date(item.endTime);
				if(nowTime < beginTime) {
					this.$message({
						type: 'info',
						message: '作业时间未到！',
					})
					return;
				}
				if(nowTime > endTime) {
					this.$message({
						type: 'info',
						message: '作业时间已结束！',
					})
					return;
				}
				this.taskId = item.id;
				this.taskOpenIndex = true;
			},
			infoTask(item) {
				this.taskId = item.id;
				this.recordId = item.recordId;
				this.taskOpenInfo = true;
			},
			finiOnAppend(row) {
				this.$refs.centerfiniOnTable.toggleRowExpansion(row)
			},
			clearfiniOnFilter() {
				this.finiOnname = '';
				this.finiOntypeId = '';
				this.finiOntaskName = '';
				this.finiOnuserName = '';
				this.finiOncurrent = 1
				this.getfiniOnListData();
			},
			finiOnCurrentChange(finiOncurrent) {
				this.finiOncurrent = finiOncurrent;
				this.getfiniOnListData();
			},
			getfiniOnListData() {
				var data = {
					isFinish: false,
					name: this.finiOntaskName ? this.finiOntaskName : null,
					createUsername: this.finiOnuserName ? this.finiOnuserName : null,
					vrName: this.finiOnname ? this.finiOnname : null,
					typeId: this.finiOntypeId ? this.finiOntypeId : null,
					current: this.finiOncurrent,
					limit: this.limit,
					majorId: this.majorIdForAll,
				}
				getUserTaskRecordCenter(data).then(res => {
					if(res.code == "OK") {
						this.finiOnlistData = res.data.records;
						this.finiOntotal = res.data.total;
					}
				})
			},
			finiOffAppend(row) {
				this.$refs.centerfiniOffTable.toggleRowExpansion(row)
			},
			clearfiniOffFilter() {
				this.finiOffname = '';
				this.finiOfftypeId = '';
				this.finiOfftaskName = '';
				this.finiOffuserName = '';
				this.finiOffcurrent = 1
				this.getfiniOffListData();
			},
			finiOffCurrentChange(finiOffcurrent) {
				this.finiOffcurrent = finiOffcurrent;
				this.getfiniOffListData();
			},
			getfiniOffListData() {
				var data = {
					isFinish: true,
					name: this.finiOfftaskName ? this.finiOfftaskName : null,
					createUsername: this.finiOffuserName ? this.finiOffuserName : null,
					vrName: this.finiOffname ? this.finiOffname : null,
					typeId: this.finiOfftypeId ? this.finiOfftypeId : null,
					current: this.finiOffcurrent,
					limit: this.limit,
					majorId: this.majorIdForAll,
				}
				getUserTaskRecordCenter(data).then(res => {
					if(res.code == "OK") {
						this.finiOfflistData = res.data.records;
						this.finiOfftotal = res.data.total;
					}
				})
			},
			getTypeList() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(res => {
					this.typeList = res.data;
				})
			},
			getLabInfo(item) {
				this.$router.push({
					name: 'fictitiousinfo',
					query: {
						vrDetailId: item.id,
						resourceId:resourceId,
						toTab:'task'
					}
				})
			},
		}
	}
</script>